import classNames from 'classnames';
import { useAtom } from 'jotai';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import ButtonSwitchMulti, {
  ButtonSwitchMultiOption,
} from '../../components/actions/ButtonSwitchMulti';
import { Spacer } from '../../components/layout/Spacer';
import { ActionBar } from '../../components/nav/ActionBar';
import ActualityAggregateByGroupSelector from '../components/ActualityAggregateByGroupSelector';
import { actualityAggregatedStatsGroupBySecondary } from '../store/actuality.kpi.state';
import { ActualityAggregatedStatsViewMode } from '../store/actuality.kpi.types';
import { actualityAggregatedStatsViewModeSelected } from '../store/actuality.kpi.ui.state';

const ActualityAggregatedStatsControls: React.FC = () => {
  const { t } = useTranslation('feed');

  const [viewModeSelected, setViewModeSelected] = useAtom(
    actualityAggregatedStatsViewModeSelected,
  );

  const [subGroup, setSubGroup] = useRecoilState(
    actualityAggregatedStatsGroupBySecondary,
  );

  const viewModeOptions: (ButtonSwitchMultiOption & {
    id: ActualityAggregatedStatsViewMode;
  })[] = [
    {
      id: 'dashboard',
      // 'heatmap',
      label: t`Metrics`,
    },
    {
      id: 'chart',
      //'chart',
      label: t`Chart`,
    },

    {
      id: 'compare',
      // 'all',
      label: t`Compare`,
    },
    {
      id: 'heatmap',
      // 'heatmap',
      label: t`Heatmap`,
    },
    {
      id: 'table',
      // 'table',
      label: t`Table`,
    },
  ];

  return (
    <ActionBar className={classNames('p-2')} sticky>
      <ButtonSwitchMulti
        className="mx-2"
        autoSize
        selectedIndex={viewModeOptions.findIndex(
          o => o.id === viewModeSelected,
        )}
        onClick={index => {
          setViewModeSelected(viewModeOptions[index].id);
        }}
        options={viewModeOptions}
        buttonType="secondary"
      />

      <Spacer flexspace />

      <ActualityAggregateByGroupSelector
        value={subGroup}
        onChange={v => setSubGroup(v)}
      />
    </ActionBar>
  );
};

export default ActualityAggregatedStatsControls;
